exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2-UeN{height:auto;-webkit-box-sizing:initial;box-sizing:initial;width:70px}", ""]);

// exports
exports.locals = {
	"spareImage": "_2-UeN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SpareImg/SpareImg.css
// module id = 1793
// module chunks = 0 15 17 22 32 36